<template>
  <div>
    <under-input v-model="item.name">
      Name
    </under-input>
    <under-text-area-md v-model="item.description" rows="6">
      Description
    </under-text-area-md>
  </div>
</template>
<script>
import UnderInput from "../shared/_UnderInput.vue";
import UnderTextAreaMd from "../shared/_UnderTextAreaMd.vue";

export default {
  name: "shared-notes-default",
  components: {
    UnderInput,
    UnderTextAreaMd
  },
  props: ["section", "item"]
};
</script>
